import PitchDeck from "@/components/PitchDeck";
import "@/App.css";

function App() {
  return <PitchDeck />;
}

export default App;
